import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonPage = _resolveComponent("CommonPage")!

  return (_openBlock(), _createBlock(_component_CommonPage, { page: _ctx.page }, null, 8, ["page"]))
}